import '../../../scss/module/user/concessionary_list.scss'

import $ from 'jquery';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/images/marker-icon.png';
import 'leaflet/dist/images/marker-icon-2x.png';

import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

import './../../../scss/sipder_map.scss';

let map_id = '#spider-map'
let mobile_map_id = '#spider-map-mobile'
if ($(map_id).is(':hidden')) {
  map_id = mobile_map_id
}

let $csrf = $('[name="csrfmiddlewaretoken"]').attr('value');

let icon_url = $('div#spider-map').data('icon-url');

L.Marker.prototype.setIcon(L.icon({
  iconUrl: icon_url,
  iconSize: [32, 32],
  iconAnchor: [16, 32]
}))

window.mymap = null;
window.markers = null;
window.denied_zoom = false;
window.nb_markers = 0;
window.current_locality = null;

function debounce(func, wait) {
  let timeout;
  return function(...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

$(function() {
  let spider_map = $(map_id);
  if (!spider_map.length)
    return;

  load_map_url(spider_map, null, null, null, null, true)

  $(document).on('click', 'button#pills-map-tab', function () {
    window.mymap.invalidateSize()
  });

  let params = window.location.search;
  let locality = null;
  if (params && params.length) {
    locality = params.replace('?locality=', '');
  }

  $(document).on('submit', 'form#search-concessionary', function(e) {
    e.preventDefault();
    let value = $('#id_locality :selected').val();
    window.current_locality = value;
    if (locality) {
      let url = new URL(window.location.origin + window.location.pathname);
      url.searchParams.append('locality', value);
      window.history.pushState({}, '', url);
    }
    reload_concessionary_and_map(JSON.stringify({'locality': value}), window.mymap, window.markers)
    return false;
  })

  setTimeout(function(){
    if (window.mymap) {
      window.mymap.on('moveend', debounce(function () {
          if (!window.denied_zoom)
             zoom();
      }, 400));
    }
  }, 2000)
});

function count_markers() {
  if (!window.mymap)
    return 0;
  let counter = 0;
  window.mymap.eachLayer((layer)=>{
    if (layer._childCount)
      counter += layer._childCount;
  });
  return counter;
}

function load_map_url(elem, url=null, zoom=null, $mymap=null, $markers=null,
                      no_fly=false, reload=true) {
  if (!url)
    url = elem.attr('data-url');
  if (!zoom)
    zoom = elem.attr('data-zoom');
  $.ajax({
    url: url,
    headers: {'X-CSRFToken': $csrf},
    type: 'get',
    success : function(response, status) {
      initialize_map(response, elem, zoom, $mymap, $markers, no_fly, reload)
    },
    error: function(response, status) {
      console.log('error', response, status)
    }
  });
}

function initialize_map(data, elem, zoom, $mymap=null, $markers=null, no_fly=false, reload=true) {
  if (!data || elem.length === 0 || (!reload && window.nb_markers === count_markers()))
    return;
  if (!$mymap) {
    $mymap = L.map(elem.attr('id')).setView(
      [data['center']['lat'], data['center']['lng']], zoom
    );
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: "© Les contributeurs d'<a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a>"
    }).addTo($mymap);
  }
  else if(!no_fly && data['center'] && data['center']['lat'] != null) {
    window.denied_zoom = true;
    $mymap.flyTo(
      [data['center']['lat'], data['center']['lng']], zoom
    );
    // re-set nb_markers because user has select location
    window.nb_markers = count_markers();
    window.denied_zoom = false;
  }

  if ($markers)
    $mymap.removeLayer($markers);
  $markers = new window.L.markerClusterGroup();
  $.each(data['location'], function(key, value) {
    if (value['lat_lng'] && value['lat_lng'].length > 0) {
      let marker = L.polygon(value['lat_lng'])
        .bindPopup(value['bubble_content']).openPopup();
      $markers.addLayer(marker);
    }
    else {
      let marker = L.marker([value['lat'], value['lng']])
        .bindPopup(value['bubble_content']).openPopup();
      $markers.addLayer(marker);
    }
  });

  $mymap.addLayer($markers);
  $mymap.invalidateSize();

  if (window.nb_markers === 0) {
    let val = $('span.nb-concessionary').html()
    if ($.isNumeric(val))
      window.nb_markers = parseInt(val);
  }

  window.mymap = $mymap
  window.markers = $markers
}

function zoom() {
  if (!window.denied_zoom) {
    window.denied_zoom = true;
    reload_map(window.mymap, window.markers, true, false);
    window.denied_zoom = false;
  }
}

function reload_map($mymap, $markers, no_fly=false, reload=true) {
  if ($(map_id).is(':hidden')) {
    console.log("Map cachée, pas de reload par bounds");
    return;
  }
  let bounds = $mymap.getBounds()
  let south_west = bounds.getSouthWest().wrap();
  let north_east = bounds.getNorthEast().wrap();
  let data = {
    'latlng': {
      'sw_lat': south_west.lat, 'sw_lng': south_west.lng,
      'ne_lat': north_east.lat, 'ne_lng': north_east.lng
    }
  }
  if (window.current_locality) {
    data['order_by'] = window.current_locality;
    window.current_locality = null;
  }
  data = JSON.stringify(data)
  reload_concessionary_and_map(data, $mymap, $markers, no_fly, reload)
}

function reload_concessionary_and_map(data, $mymap, $markers, no_fly=false, reload=true, reset=false) {
  let url = $('form#search-concessionary').attr('action');
  $.ajax({
    url: url,
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRFToken': $csrf},
    data: data,
    type: 'POST',
  }).done(function(data) {
    $('div.concessionary-listing').html(data)
    let new_map = $('.new-map')
    let url = new_map.data('url');
    let zoom = new_map.data('zoom');
    load_map_url($(map_id), url, zoom, $mymap, $markers, no_fly, reload)
  });
}
